import { getApiOrigin } from '@hungryroot/rest';

/**
 * This could be a generic util used by client-facing apps as well
 *
 * @param {*} url
 * @param {*} payload
 * @returns
 */
export const httpPost = async (url, payload) => {
  const apiOrigin = getApiOrigin();
  return new Promise((resolve, reject) => {
    let xhr = $.ajax({
      url: `${apiOrigin}${url}`,
      type: 'POST',
      dataType: 'json',
      contentType: 'application/json',
      data: JSON.stringify(payload),
    });

    xhr.done((data) => {
      resolve(data);
    });

    xhr.fail((jqXHR, textStatus, errorThrown) => {
      const errMsg = (jqXHR.responseJSON || {}).error || errorThrown;
      reject({
        status: jqXHR.status,
        message: payload.errorPrefix
          ? `${payload.errorPrefix}: ${errMsg}`
          : errMsg,
      });
    });
  });
};

export const httpGet = async (url, params = {}) => {
  const apiOrigin = getApiOrigin();
  return new Promise((resolve, reject) => {
    let xhr = $.ajax({
      url: `${apiOrigin}${url}`,
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json',
      data: params,
    });

    xhr.done((newData) => {
      resolve(newData);
    });

    xhr.fail((jqXHR, textStatus, errorThrown) => {
      const errMsg = (jqXHR.responseJSON || {}).error || errorThrown;
      reject({
        status: jqXHR.status,
        message: params.errorPrefix
          ? `${params.errorPrefix}: ${errMsg}`
          : errMsg,
      });
    });
  });
};

const httpGetFailSilently = async (url, params = {}) => {
  const apiOrigin = getApiOrigin();
  return new Promise((resolve, reject) => {
    let xhr = $.ajax({
      url: `${apiOrigin}${url}`,
      type: 'GET',
      dataType: 'json',
      contentType: 'application/json',
      data: params,
    });

    xhr.done((newData) => {
      resolve(newData);
    });

    xhr.fail((jqXHR, textStatus, errorThrown) => {
      resolve(null);
    });
  });
};
